module.exports = __webpack_public_path__ + "static/media/Profile.6e61834d.jpeg";